import { makeStyles } from '@material-ui/core';
import Colors from '../../components/Colors';
export const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexFlow: 'column',
        boxSizing: 'border-box',
        marginTop: '2%',
    },
    content: {
        display: "flex",
        flexDirection: "column",
        alignSelf: "center",
        boxSizing: 'border-box',
        width: "60rem",
        marginTop: "4rem",
        flex: 1,
    },
    loadingContainer: {
        display: 'flex',
        marginTop: '30px',
        justifyContent: 'center',
      },
      loadingSpinner: {
        color: '#404040',
      },
}))